// extracted by mini-css-extract-plugin
export default {"container":"SectionHorizontal_container__KBk9M"};